(function () {
  'use strict';
  /* Customer photo carousel (sections/pdp-ugc.liquid): arrows step one card. */
  document.querySelectorAll('[data-ugc]').forEach(function (root) {
    var track = root.querySelector('[data-ugc-track]');
    if (!track) return;
    root.querySelectorAll('[data-ugc-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = track.querySelector('.ugc__card');
        var step = card ? card.getBoundingClientRect().width + 14 : track.clientWidth;
        var max = track.scrollWidth - track.clientWidth;
        var next = track.scrollLeft + Number(btn.getAttribute('data-ugc-step')) * step;
        if (next > max + 2) next = 0;
        if (next < -2) next = max;
        track.scrollTo({left: next, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      });
    });
    // Each customer's own photos: arrows inside the card, dots follow swipes.
    root.querySelectorAll('[data-ugc-slider]').forEach(function (slider) {
      var slides = slider.querySelector('[data-ugc-slides]');
      var dots = slider.querySelectorAll('.ugc__dots span');
      function index() { return Math.round(slides.scrollLeft / slides.clientWidth); }
      function sync() {
        var i = index();
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      }
      slider.querySelectorAll('[data-ugc-photo]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var count = slides.children.length;
          var next = (index() + Number(btn.getAttribute('data-ugc-photo')) + count) % count;
          // Instant, not smooth: Chrome drops smooth scrolls on a snap strip
          // nested inside the horizontally scrolling card row.
          slides.scrollTo({left: next * slides.clientWidth, behavior: 'auto'});
          sync();
        });
      });
      slides.addEventListener('scroll', sync, {passive: true});
      slides.addEventListener('scrollend', sync);
    });
  });
  document.querySelectorAll('[data-pdp-media]').forEach(function (media) {
    /* Conversion layout: one image at a time on every screen size, so the
       arrows step the same scroll-snap track the phone swipe uses. */
    var track = media.querySelector('[data-pdp-track]');
    media.querySelectorAll('[data-pdp-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!track) return;
        var step = Number(btn.getAttribute('data-pdp-step'));
        var max = track.scrollWidth - track.clientWidth;
        var next = track.scrollLeft + step * track.clientWidth;
        if (next > max + 2) next = 0;
        if (next < -2) next = max;
        track.scrollTo({left: next, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      });
    });
    var more = media.querySelector('[data-pdp-more]');
    if (more) {
      media.classList.add('pdp-media--collapsible');
      more.hidden = false;
      var label = more.textContent;
      more.addEventListener('click', function () {
        var expanded = media.classList.toggle('is-expanded');
        more.setAttribute('aria-expanded', String(expanded));
        more.textContent = expanded ? window.Nutritia.t('show_fewer', 'Show fewer photos −') : label;
      });
    }
    if (!window.HTMLDialogElement || !HTMLDialogElement.prototype.showModal) return;
    var dialog = document.createElement('dialog');
    dialog.className = 'pdp-lightbox';
    dialog.setAttribute('aria-label', window.Nutritia.t('image_viewer', 'Product image viewer'));
    var close = document.createElement('button');
    close.type = 'button'; close.className = 'pdp-lightbox__close'; close.textContent = window.Nutritia.t('close', 'Close');
    var large = document.createElement('img');
    var full = document.createElement('a');
    full.className = 'pdp-lightbox__link'; full.textContent = window.Nutritia.t('open_full', 'Open full-size image'); full.target = '_blank'; full.rel = 'noopener';
    dialog.append(close, large, full); document.body.appendChild(dialog);
    var previousOverflow = '';
    close.addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
    dialog.addEventListener('close', function () { document.documentElement.style.overflow = previousOverflow; });
    media.querySelectorAll('.pdp-tile img').forEach(function (img) {
      /* Keep the image as the direct child of its tile. Wrapping it in a
         button changes the grid item's intrinsic height on some mobile
         browsers, which makes the gallery appear clipped or blank. */
      img.classList.add('pdp-zoom-image');
      img.setAttribute('tabindex', '0');
      img.setAttribute('role', 'button');
      img.setAttribute('aria-label', window.Nutritia.t('enlarge', 'Enlarge {alt}', {alt: img.alt || window.Nutritia.t('product_photo', 'product photo')}));
      var open = function () {
        large.src = img.src; large.alt = img.alt; full.href = img.src;
        previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden'; dialog.showModal();
      };
      img.addEventListener('click', open);
      img.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); }
      });
    });
  });
})();
